import { useEffect, useState } from 'react';
import { api, type ListResult } from '../api';

interface PO {
  id: string;
  poNumber: string;
  status: string;
  currency: string;
  total: unknown;
}

const STATUSES = ['draft', 'issued', 'fulfilled', 'cancelled'];
const num = (v: unknown) => Number(v ?? 0);

export function PurchaseOrdersPage() {
  const [pos, setPos] = useState<PO[]>([]);

  async function load() {
    const res = await api.get<ListResult<PO>>('/api/purchase-orders');
    setPos(res.items);
  }

  useEffect(() => {
    void load();
  }, []);

  async function setStatus(po: PO, status: string) {
    await api.post(`/api/purchase-orders/${po.id}/status`, { status });
    await load();
  }

  return (
    <div className="card">
      <h1>Purchase orders</h1>
      <p className="muted">Created by converting an accepted quote (Quotes → “→ PO”).</p>
      <table className="grid">
        <thead><tr><th>Number</th><th>Status</th><th>Total</th><th></th></tr></thead>
        <tbody>
          {pos.map((po) => (
            <tr key={po.id}>
              <td>{po.poNumber}</td>
              <td>
                <select value={po.status} onChange={(e) => void setStatus(po, e.target.value)}>
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </td>
              <td>{po.currency} {num(po.total).toFixed(2)}</td>
              <td><a className="btn" href={`/api/purchase-orders/${po.id}/pdf`} target="_blank" rel="noreferrer">PDF</a></td>
            </tr>
          ))}
          {pos.length === 0 && <tr><td colSpan={4} className="empty">No purchase orders yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
